/**
 * Порог тишины: ниже него заливка пустая, чтобы шипение комнаты не качало иконку.
 * Обычная речь (RMS около 0.08 после getUserMedia) уже доходит до полной заливки.
 */
const NOISE_FLOOR = 0.015
const SPEECH_RMS = 0.08

/** Доля подъёма за кадр и более медленный спад — заливка не дрожит на каждом сэмпле. */
const ATTACK = 0.55
const RELEASE = 0.18

/**
 * Громкость time-domain сэмплов AnalyserNode (байты вокруг 128) → 0…1.
 * Пустой буфер и шум пола — 0, громче обычной речи — 1.
 */
export function micFillLevel(samples: Uint8Array): number {
  if (samples.length === 0) return 0
  let sum = 0
  for (let i = 0; i < samples.length; i++) {
    const centered = ((samples[i] ?? 128) - 128) / 128
    sum += centered * centered
  }
  const rms = Math.sqrt(sum / samples.length)
  if (rms <= NOISE_FLOOR) return 0
  const linear = Math.min(1, (rms - NOISE_FLOOR) / (SPEECH_RMS - NOISE_FLOOR))
  return Math.sqrt(linear)
}

/** Быстрый подъём, более медленный спад. Равные значения не двигает. */
export function smoothMicFill(previous: number, next: number): number {
  if (next === previous) return previous
  const rate = next > previous ? ATTACK : RELEASE
  return previous + (next - previous) * rate
}
